import {useEffect, useState} from 'react';

/**
 * The Tools list has to re-check suggestions as the draft changes, including
 * after Ctrl+Z. The editor view object itself does not change on each
 * transaction, so poll the document reference while a panel is mounted.
 */
export function useLiveEditorDoc(editorView) {
    const [doc, setDoc] = useState(() => editorView?.state?.doc ?? null);

    useEffect(() => {
        if (!editorView) {
            setDoc(null);
            return undefined;
        }
        setDoc(editorView.state.doc);
        const timer = setInterval(() => {
            const next = editorView.state?.doc ?? null;
            setDoc((current) => (current === next ? current : next));
        }, 150);
        return () => clearInterval(timer);
    }, [editorView]);

    return doc;
}
